import { UserResponse } from 'stream-chat';
import { GetStreamUser } from '../types/GetStreamUser';

export const fetchUsersFromGetStream = async (client, filter): Promise<GetStreamUser[]> => {
    const response = await client.queryUsers(filter);
    return response.users.map(convertGetStreamUser);
};

const convertGetStreamUser = (userResponse: UserResponse): GetStreamUser => ({
    company: (userResponse.company as string) || '',
    country: (userResponse.country as string) || '',
    emails: (userResponse.emails as string[]) || [],
    firstName: (userResponse.firstName as string) || '',
    groupId: (userResponse.groupId as number) || 0,
    id: 0,
    industry: (userResponse.industry as string) || '',
    lastName: (userResponse.lastName as string) || '',
    photoUrl: (userResponse.photoUrl as string) || '',
    primaryEmail: (userResponse.primaryEmail as string) || '',
    primaryEmailValid: (userResponse.primaryEmailValid as boolean) || true,
    status: (userResponse.status as string) || '',
    title: (userResponse.title as string) || '',
    anonymous: (userResponse.anonymous as boolean) || false,
    admin: (userResponse.admin as boolean) || false,
    photoSet: undefined,
    providerId: userResponse.id,
});
